import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import get from 'lodash/get';

import Card from 'components/Card';
import Spinner from 'components/Spinner';
import PriceSelectCompetitor from 'modules/Prices/pages/price/components/SelectCompetitor';
import PriceNetworkChart from 'modules/Prices/pages/price/components/GraphByNetworks/chart';
import PriceNetworkHeader from 'modules/Prices/pages/price/components/GraphByNetworks/header';
import PriceChartDiv from 'modules/Prices/components/StyledDiv/graph';

import { components } from 'apiTyped/types';
import { MarketOption } from 'interface';
import { RivalsByVintage } from 'interface/price';

const PriceDiv = styled.div`
  position: relative;
  display: grid;
`;

const PriceNetwork = ({
  data,
  wine,
  vintage,
  format,
  vintagesByWine,
  exportName,
  showVintages,
  isLoading,
  competitor,
  competitorVintage,
  setCompetitor,
  setCompetitorVintage
}: {
  wine: string;
  vintage: string | null;
  format: string | null;
  data: components['schemas']['DataDetail'][];
  vintagesByWine: RivalsByVintage;
  exportName: string;
  showVintages: boolean;
  isLoading: boolean;
  competitor: string | null;
  competitorVintage?: string | null;
  // eslint-disable-next-line no-unused-vars
  setCompetitor: (e: string | null) => void;
  // eslint-disable-next-line no-unused-vars
  setCompetitorVintage?: (e: string | null) => void;
}) => {
  const [activeRadioButton, setActiveRadioButton] =
    useState('Aucune comparaison');
  const [market, setMarket] = useState<MarketOption | null>(null); // type: dict
  const [currency, setCurrency] = useState<string>('EUR'); // type: string

  // Set currency when data changes
  useEffect(() => {
    if (data.length > 0) {
      setCurrency(get(data, '[0].displayed_currency', 'EUR'));
    }
  }, [data]);

  const onChangeCompetitor = (competitor: string | null) => {
    setCompetitor(competitor);
    setActiveRadioButton('Comparer avec un concurrent');
  };

  const onChangeMarket = (value: MarketOption | null) => {
    setCurrency(
      value ? value.currency : get(data, '[0].displayed_currency', 'EUR')
    );
    setMarket(value);
  };

  return (
    <PriceChartDiv>
      <PriceDiv>
        <Card id="prices-prix-moyen-barre">
          <PriceNetworkHeader
            data={data}
            market={market}
            exportName={exportName}
            setMarket={onChangeMarket}
          />
          <PriceNetworkChart
            data={data}
            activeRadioButton={activeRadioButton}
            currency={currency}
            market={market}
            wine={wine}
            vintage={vintage}
            format={format}
            competitor={competitor}
            competitorVintage={competitorVintage}
          />
          <PriceSelectCompetitor
            competitor={competitor}
            competitorVintage={competitorVintage}
            onChangeCompetitor={onChangeCompetitor}
            onChangeCompetitorVintage={setCompetitorVintage}
            vintagesByWine={vintagesByWine}
            showVintages={showVintages}
            vintage={vintage}
          />
        </Card>
        <Spinner loading={isLoading} little />
      </PriceDiv>
    </PriceChartDiv>
  );
};

export default PriceNetwork;
